// extracted by mini-css-extract-plugin
export default {"noData":"styles_noData__OCEaS"};